import React from 'react'
import history from '../../../lib/history'
import routes from '../../../config/routes'
import Button from '../../commons/Button/Button'
import Flex from '../../commons/Flex/Flex'
import Text from '../../commons/Text/Text'
import ConsultorMaisBlack from '../../commons/Icons/ConsultorMaisBlack'
import NotFound from '../../commons/Ilustrations/NotFound'
import Menu from '../../commons/Menu/Menu'
import styles from './page404Container.module.scss'

const Page404 = () => {
  return (
    <div className={styles.container}>
      <div className={styles.subcontainer}>
        <div className={styles.flex}>
          <div className={styles.content}>
            <ConsultorMaisBlack />
            <div>
              <Text
                color="gray"
                variation="dark"
                extraBold
                className={styles.title}
              >
                Página não encontrada
              </Text>
              <Text
                size="md"
                lineHeight="30px"
                color="gray"
                variation="dark"
                fontWeight="400"
              >
                Não encontramos a página que você procura. Sugerimos que você
                volte ao início enquanto corrigimos o problema.
              </Text>
              <Button
                type="secondary"
                buttonType="button"
                margin="24px 0px 0px 0px"
                width="160px"
                onClick={() => history.replace(routes.wallet.path)}
              >
                <Text color="white" size="xs" font="custom" lineHeight="20px">
                  Ir para o início
                </Text>
              </Button>
            </div>
            <Menu />
          </div>
        </div>
        <Flex column alignItems="center" justifyContent="center">
          <NotFound />
        </Flex>
      </div>
    </div>
  )
}

export default Page404
